import { formatOrgNum } from "@/utils/other";
import { observer } from "mobx-react";
import { Alert } from "@/components-v2/Alert";
import { ChangeOfAuditorForm } from "./auditorDomain";
import { VBox } from "@/components-v2/Box";
import { Autocomplete } from "@/components-v2/Autocomplete";
import { MTextInput } from "@/components-v2/TextInput";

import { useTranslation } from "@/stores/RootStoreContext";

const AuditorAutocomplete = observer(function AuditorAutocomplete({
  form,
}: {
  form: ChangeOfAuditorForm;
}) {
  const { t } = useTranslation();
  return (
    <VBox>
      <Autocomplete
        label={t("decisions.auditor.select")}
        disabled={form.isProjectLocked}
        items={form.suggestedCompanyForAuditors}
        value={form.selectedCompanyForAuditor}
        idFn={(item) => item.organizationnumber}
        labelFn={(item) => item.name}
        inputValue={form.searchCompanyModel.inputValue}
        onInputValueChange={form.setCompanySearch}
        onSelect={form.setSelectedCompanyForAuditor}
        onClear={form.clearSelectedAuditor}
      />
      {form.validationError && <Alert type={"error"} message={<>{t(form.validationError)}</>} />}
    </VBox>
  );
});

export const ChangeOfAuditorView = observer(function ChangeOfAuditorView({
  form,
}: {
  form: ChangeOfAuditorForm;
}) {
  const { t } = useTranslation();
  const orgNoPrefix = t("decisions.auditor.orgNoPrefix");

  return (
    <VBox gap={"md"}>
      {form.currentAuditor ? (
        <div>
          <div>{t("decisions.auditor.company-auditor-now")}</div>
          {`${form.currentAuditor.name} (${orgNoPrefix} ${formatOrgNum(
            form.currentAuditor.organisationNumber,
          )})`}
        </div>
      ) : (
        <div>
          <div>{t("decisions.auditor.company-no-auditor")}</div>
        </div>
      )}
      <AuditorAutocomplete form={form} />
      {form.selectedCompanyForAuditor && (
        <VBox gap="md">
          <div>
            <div>{t("decisions.auditor.company-auditor-willbe")}</div>
            <strong>{form.selectedCompanyForAuditor.name}</strong>
            {` (${orgNoPrefix} ${formatOrgNum(form.selectedCompanyForAuditor.organizationnumber)})`}
          </div>
          <MTextInput model={form.emailModel} label={t("decisions.auditor.email")} />
        </VBox>
      )}
    </VBox>
  );
});
